import { ComponentType } from 'react'

import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

import { useIsInvoiceEditorElementRestricted } from '../../../../../../../../../../../../../../hooks/useIsInvoiceEditorElementRestricted'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'
import { InvoiceLineDate } from '../InvoiceLineDate'
import { InvoiceLineDiscount } from '../InvoiceLineDiscount'
import { InvoiceLineProductName } from '../InvoiceLineProductName'
import { InvoiceLineProductType } from '../InvoiceLineProductType'
import { InvoiceLineQuantity } from '../InvoiceLineQuantity'
import { InvoiceLineTotalExcludingVat } from '../InvoiceLineTotalExcludingVat'
import { InvoiceLineTotalIncludingVat } from '../InvoiceLineTotalIncludingVat'
import { InvoiceLineUnit } from '../InvoiceLineUnit'
import { InvoiceLineUnitPrice } from '../InvoiceLineUnitPrice'
import { InvoiceLineVat } from '../InvoiceLineVat'

type InvoiceLineColumnFields = {
  [key in InvoiceLineColumn]: ComponentType<CommonInvoiceLineFieldProps> | null
}

const columnComponents: Partial<InvoiceLineColumnFields> = {
  description: InvoiceLineProductName,
  discount: InvoiceLineDiscount,
  productType: InvoiceLineProductType,
  date: InvoiceLineDate,
  quantity: InvoiceLineQuantity,
  unit: InvoiceLineUnit,
  unitPrice: InvoiceLineUnitPrice,
  vatPct: InvoiceLineVat,
  netTotal: InvoiceLineTotalExcludingVat,
  total: InvoiceLineTotalIncludingVat,
}

interface InvoiceLineFieldProps extends Omit<CommonInvoiceLineFieldProps, 'disabled'> {
  column: InvoiceLineColumn
}

export const InvoiceLineField = ({ column, lineIndex }: InvoiceLineFieldProps) => {
  const isDisabled = useIsInvoiceEditorElementRestricted(column, 'disabled')
  const FieldComponent = columnComponents[column]

  return FieldComponent ? <FieldComponent disabled={isDisabled} lineIndex={lineIndex} /> : null
}
